import { Navigate, Route, Routes } from 'react-router-dom'
import VesselCreate from '../../../Pages/Vessel/VesselCreate'
import VesselView from '../../../Pages/Vessel/VesselView'
import VesselSwap from '../../../Pages/Vessel/VesselSwap'
import VesselViewSelect from '../../../Pages/Vessel/VesselViewSelect'
import VesselModule from '../../../Contexts/Modules/SampleModule/VesselModule'
import RenderMessage from '../../../garvan-react/Components/ModalFeedback/RenderMessage'
import * as React from 'react'
import NotFound from '../../NotFound'

function VesselRouter() {
  return (
    <Routes>
      <Route
        index
        element={
          <RenderMessage
            message={{
              message: '',
              subject: 'Please select page from the menu',
              severity: 'info',
              loading: false,
            }}
          />
        }
      />
      <Route
        path="create"
        element={<VesselCreate />}
      />
      <Route
        path="swap"
        element={<VesselSwap />}
      />
      <Route
        path="select"
        element={<VesselViewSelect />}
      />
      <Route path="info">
        <Route
          index
          element={
            <Navigate
              to={'select'}
              replace={true}
            />
          }
        />
        <Route
          path=":vessel_id"
          element={
            <VesselModule>
              <VesselView />
            </VesselModule>
          }
        />
      </Route>
      <Route path="holding">
        <Route
          index
          element={
            <Navigate
              to={'select'}
              replace={true}
            />
          }
        />
        <Route
          path=":holding_id"
          element={
            <VesselModule>
              <VesselView />
            </VesselModule>
          }
        />
      </Route>
      <Route
        path="*"
        element={<NotFound />}
      />
    </Routes>
  )
}

export default VesselRouter
